<app-shipment-system-simplenav></app-shipment-system-simplenav>
<div class="container">

<div class="card  mt-3">
    <div class="card-body">
        <p *ngIf="!bundle" class="text-center  text-muted  mt-2">Indlæser ...</p>

        <div *ngIf="bundle && users">
            <div class="d-flex  justify-content-between  mb-4">
                <div>
                    <button class="btn  btn-primary" (click)="save()">Gem</button>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="bundle-name">Navn</label>
                        <input type="text" [(ngModel)]="bundle.name" class="form-control" id="bundle-name" name="bundle-name">
                    </div>
                </div>

                <div class="col-md-4">

                    <label class="control-label" i18n>Branch</label>
                    <span *ngIf="saving" class="text-muted" style="margin-left: 10px;" i18n>Saving...</span>
                    <select class="form-control form-select"
                            name="shipment-route-id"
                            (change)="branchChanged()"
                            [(ngModel)]="bundle.branch"
                            [disabled]="saving">
                        <option i18n [value]="null">No Driver assigned</option>
                        <ng-template ngFor let-branch [ngForOf]="branches">
                            <option [value]="branch.key">{{ branch.name }}
                            </option>
                        </ng-template>
                    </select>
                </div>

                <div class="col-md-4">

                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label for="scanapp_external_reference">ScanApp ID</label>
                        <input type="text" [(ngModel)]="bundle.scanapp_external_reference" class="form-control" id="scanapp_external_reference" name="scanapp_external_reference">
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label for="external_reference">Consignor ID</label>
                        <input type="text" [(ngModel)]="bundle.external_reference" class="form-control" id="external_reference" name="external_reference">
                    </div>

                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Bruger</label><br>

                        <select class="form-control form-select"
                                [(ngModel)]="bundle.user_id"
                                name="user-id" ngModel>
                            <option i18n [ngValue]="null">None</option>
                            <option *ngFor="let user of users"
                                    [ngValue]="user.id">{{user.name}}                                    </option>
                        </select>

                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
</div>
